export default "__VITE_ASSET__CyIenlht__"